import { rtc } from '$model/rtc'

import useSignal from './useSignal'

export const useCurrentAuthRTC = () => {
  const instance = useSignal(rtc)

  return instance
}

export default useCurrentAuthRTC
